import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { TextField, Button, Container, Typography, Box, CircularProgress, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Headrepage from "../../mainpage/Headerpages/OrganizationsHeaderpage";
import { OrganizationsGenerateOtp, OrganizationsVerifyOtp, OrganizationsForgotPassword } from '../../../helper/base_url';

export default function ResetPassword() {
  const [username, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [emailVerificationToken, setEmailVerificationToken] = useState(null);
  const [step, setStep] = useState(1);
  const [timer, setTimer] = useState(60);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (step === 2 && timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [step, timer]);

  const notify = (message, type) => {
    toast[type](message);
  };

  const requestOTP = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${OrganizationsGenerateOtp}`, { username });
      setEmailVerificationToken(response.data.emailVerificationToken);
      setStep(2);
      setTimer(60);
      notify("OTP sent successfully!", "success");
    } catch (error) {
      console.error("Error sending OTP:", error);
      notify("Failed to send OTP. Try again.", "error");
    }
    setLoading(false);
  };

  const verifyOTP = async () => {
    setLoading(true);
    try {
      await axios.post(`${OrganizationsVerifyOtp}`, { username, code: otp, emailVerificationToken });
      setStep(3);
      notify("OTP verified successfully!", "success");
    } catch (error) {
      console.error("Error verifying OTP:", error);
      notify("Invalid OTP. Try again.", "error");
    }
    setLoading(false);
  };

  const resetPassword = async () => {
    if (newPassword !== confirmPassword) {
      notify("Passwords do not match.", "error");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${OrganizationsForgotPassword}`, { username, newPassword, emailVerificationToken });
      notify("Password reset successful!", "success");
      setTimeout(() => navigate("/organizations/signin"), 500);
      setStep(4);
    } catch (error) {
      //console.error("Error resetting password:", error);
      notify("Failed to reset password. Try again.", "error");
    }
    setLoading(false);
  };

  return (
    <div className="students-flex">
      <Headrepage />
      <div style={{ width : "100%", overflowX: "hidden", overflowY: "auto", height : "91vh" }}>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height : "80vh" }}>
        <Container maxWidth="sm">
        <Typography variant="h5" fontWeight="bold" textAlign= "center" mb={2}>Reset Password</Typography>
          <Box p={4} boxShadow={3} borderRadius={2} bgcolor="white" textAlign="center">
            <ToastContainer position="top-right" autoClose={500} hideProgressBar={false} closeOnClick pauseOnHover draggable theme="light" />
            {step === 1 && (
              <>
                <TextField label="Enter your email" variant="outlined" fullWidth value={username} onChange={(e) => setEmail(e.target.value)} margin="normal" />
                <Button variant="contained" color="primary" fullWidth onClick={requestOTP} disabled={loading}>
                  {loading ? <CircularProgress size={24} /> : "Send OTP"}
                </Button>
              </>
            )}
            {step === 2 && (
              <>
                {timer > 0 && <Typography color="error">OTP expires in {timer} seconds</Typography>}
                <TextField 
                  label="Email"
                  variant="outlined"
                  fullWidth
                  value={username}
                  onChange={(e) => setEmail(e.target.value)}
                  margin="normal"
                  disabled
                />
                <TextField label="Enter OTP" variant="outlined" fullWidth value={otp} onChange={(e) => setOtp(e.target.value)} margin="normal" />
                <Button variant="contained" color="primary" fullWidth onClick={verifyOTP} disabled={loading}>
                  {loading ? <CircularProgress size={24} /> : "Verify OTP"}
                </Button>
                {timer === 0 && <Button onClick={requestOTP} color="secondary">Resend OTP</Button>}
              </>
            )}
           {step === 3 && (
              <>
                <TextField 
                  label="Email"
                  variant="outlined"
                  fullWidth
                  value={username}
                  onChange={(e) => setEmail(e.target.value)}
                  margin="normal"
                  disabled
                />
                <TextField 
                  label="Enter new password" 
                  type={showPassword ? "text" : "password"} 
                  variant="outlined" 
                  fullWidth 
                  value={newPassword} 
                  onChange={(e) => setNewPassword(e.target.value)} 
                  margin="normal" 
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)}>
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
                
                <TextField 
                  label="Confirm new password" 
                  type={showConfirmPassword ? "text" : "password"} 
                  variant="outlined" 
                  fullWidth 
                  value={confirmPassword} 
                  onChange={(e) => setConfirmPassword(e.target.value)} 
                  margin="normal" 
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                          {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />

                <Button variant="contained" color="primary" fullWidth onClick={resetPassword} disabled={loading}>
                  {loading ? <CircularProgress size={24} /> : "Reset Password"}
                </Button>
              </>
            )}
          </Box>
           <Typography align="center" style={{ marginTop : 15 }}>
            Already have an account? <Link to="/organizations/signin">Login here</Link>
          </Typography>
        </Container>
      </Box>
      </div>
    </div>
  );
}
